//立即訂閱、menu
"use client";

import { setCRMenu, setCRShowSubscribePop } from "@/slices/cryptoReadSlice";
import { useDispatch } from "react-redux";


const CRNavFunction = () => {
  const dispatch = useDispatch();

  return (
    <div className="flex items-center [&>button]:filter-pale gap-[22px] z-10">

        {/* 登入註冊 */}
        <button
          className="usm:hidden !filter-none h-[32px] px-[18px] trans text-btn1 text-white bg-red0 rounded-[40px] border-1 border-red0 hover:text-white hover:bg-red1 hover:border-red1"
          onClick={()=> dispatch(setCRShowSubscribePop(true))}
        >
          免費訂閱電子報
        </button>

      <button
        onClick={() => dispatch(setCRMenu(true))}
        className="!filter-none h-[32px] trans text-btn1b border-b-1 border-b-[rgba(0,0,0,0)] text-red0 hover:text-black hover:border-b-black"
      >
        [ MENU ]
      </button>

    </div>
  );
};

export default CRNavFunction;
